import { Component, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { BannerSlider } from '../../models/BannerSlider/BannerSlider-model';
import { BannerSliderService } from '../../services/BannerSlider/BannerSlider.service';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { Role } from '../../models/shared/role.model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { PagerService } from '../../services/shared/pager.service';
import { ToastsManager } from 'ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
  selector: 'app-BannerSlider-list',
  templateUrl: './BannerSlider-list.component.html',
  styleUrls: ['./BannerSlider-list.component.css']
})
/** notification-list component*/
export class BannerSliderListComponent {
  public BannerSliderList: BannerSlider[];
  // pager object
  pager: any = {};
  searchQuery: string;
  pageSize: number;
  // paged items
  pagedItems: any[];
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  i: number;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** coupons-list ctor */
  constructor(private readonly BannerSlidersService: BannerSliderService,
    private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager,
    private readonly pagerService: PagerService, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("bannerslider").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.getBannerSliders();
            this.pageSize = 10;
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }


  deleteBannerSlider(id) {
    
    
    var ans = confirm("Are you sure to delete this Banner/Slider?");
    if (ans) {
      
      if (this.BannerSlidersService.deleteBannerSlider(id)) {
        this.toastr.success('Banner/Slider has been Deleted.', 'Success');
        this.getBannerSliders();
      }
     // setTimeout(()=>this.getBannerSliders(), 1500);
    }
  }
  getBannerSliders() {
    
    this.BannerSlidersService.getBannerSlider().subscribe(
      data => {
        
        this.BannerSliderList = data;
        
        for (this.i = 0; this.i <= this.BannerSliderList.length - 1; this.i++) {
          
          if (this.BannerSliderList[this.i] != null && typeof this.BannerSliderList[this.i] != "undefined") {
            let stringToSplit = this.BannerSliderList[this.i].sort;

            //if (this.BannerSliderList[this.i].brandID == 54)
            //  ;

            if (stringToSplit != null) {

  
              let x = stringToSplit.split(",");
              this.BannerSliderList[this.i].image = data[this.i].image;// '/Images/BannerSliderImages/' + this.BannerSliderList[this.i].bannerSliderID + '/' + this.BannerSliderList[this.i].bannerSliderID +'-0-img-' + x[0] + '.jpg';
            }
          }
        }
        this.filteredItems = this.BannerSliderList;
      }

    )
  }
  setPage(page: number) {

    // get pager object from service
    this.pager = this.pagerService.getPager(this.BannerSliderList.length, page, this.pageSize);

    // get current page of items
    this.pagedItems = this.BannerSliderList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {

    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.BannerSliderList, searchText);

    } else {
      this.filteredItems = this.BannerSliderList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/BannerSlider/BannerSlider-list/BannerSlider-list.component.ts